// Manually drive the app blur so it tracks the drawer's open state directly
// (Element Plus only removes its own body class AFTER the leave animation,
// which makes the blur linger). We toggle `app-blurred` on <body> on the
// open/close edge, and use a ref-count so multiple drawers don't fight.
let openCount = 0;

export function setAppBlur(on) {
  if (on) {
    openCount += 1;
  } else {
    openCount = Math.max(0, openCount - 1);
  }
  document.body.classList.toggle("app-blurred", openCount > 0);
}
